/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { CancelService } from 'models/service'

import CancelForm from 'containers/services/form/cancelForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function CancelLightbox({ status, close }: Props) {
    const formRef = useRef<FormikProps<CancelService>>(null)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Cancel Service'}
            description={
                `Once you cancel this service, all files, emails, databases and configurations will be deleted.
                To keep your data, make a full backup before cancelling your service.`
            }
            content={<CancelForm form={formRef} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Cancel Service',
                    color: 'error',
                    type: 'submit',
                    form: 'cancelForm'
                }
            ]}
        />
    )
}
